import { render, staticRenderFns } from "./GroupChatDrawer.vue?vue&type=template&id=e2533b30&"
import script from "./GroupChatDrawer.vue?vue&type=script&lang=js&"
export * from "./GroupChatDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports